var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-kpis"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpis",
    clipPath: "url(#clip-kpis)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-11.821 -11.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2102",
    "data-name": "Grupo 2102",
    transform: "translate(-3.035 3.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_801",
    "data-name": "Trazado 801",
    d: "M95.655,86.037v6.618H6.309L3,89.346V0H9.618V86.037Z",
    transform: "translate(3.618)",
    fill: "#6c637b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_802",
    "data-name": "Trazado 802",
    d: "M81.888,13.455,47.826,47.517H43.149l-10.9-10.9L8.117,60.753,3.44,56.076,29.913,29.6H34.59l10.9,10.9L79.549,6.44h4.677L97.462,19.676l-4.677,4.677Z",
    transform: "translate(4.149 7.767)",
    fill: "#6c637b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_803",
    "data-name": "Trazado 803",
    d: "M0,0H105.891V105.891H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpis);
export default __webpack_public_path__ + "static/media/kpis.b1c7f9cfb65e64af79bea79c8f53d503.svg";
export { ForwardRef as ReactComponent };